import React from "react";

interface ErrorProps {
  error: Error;
}

const ErrorComponent: React.FC<ErrorProps> = ({ error }) => {
  return (
    <div>
      <h1>Something went wrong</h1>
      <p>{error.message}</p>
    </div>
  );
};

export default ErrorComponent;
